module.exports = __webpack_public_path__ + "static/media/Rick-and-Morty.27f790ba.png";